
const jq = require('jsonpath')
const getValue = key => {
    const data = jq.query(window._PAGE_SCHEMA_, `$..${key}`)
    if (data && data.length > 0) {
        return data[0].value || data[0]
    }

};

export default getValue